import React from "react";
import st from './logo.module.scss';

const uralchemLogo = <svg width="338" height="36" viewBox="0 0 338 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M137.283 0.5V21.7333C137.079 24.7277 136.141 27.6833 132.063 27.6833V35.4611C145.93 35.4611 146.378 30.4055 146.378 21.6944V8.27777H163.304V35.4999H172.726V0.5H137.283Z"
            fill="#008B54"/>
        <path
            d="M85.6081 11.6611C85.6081 0.655554 75.3302 0.616666 66.7245 0.5H47.0251V35.4999H56.4466V22.8222H66.6837C75.2894 22.7055 85.6081 22.7055 85.6081 11.6611ZM66.3982 16.1333H56.4874V7.22777H66.3982C73.2909 7.22777 76.1051 7.22777 76.1051 11.6611C76.1051 16.1333 73.2909 16.1333 66.3982 16.1333Z"
            fill="#008B54"/>
        <path d="M22.2688 16.9889L11.8685 0.5H0L16.7628 25.8944L11.012 35.4999H22.3504L43.7219 0.5H32.3836L22.2688 16.9889Z"
              fill="#008B54"/>
        <path
            d="M99.068 0.5L82.2236 35.4999H92.4608L95.5604 28.7722H115.015L118.237 35.4999H129.127L111.589 0.5H99.068ZM98.7009 22.0444L105.104 8.19999L111.793 22.0444H98.7009Z"
            fill="#008B54"/>
        <path
            d="M316.494 0.5H307.072L295.775 28.3444L284.436 0.5H269.509V35.4999H278.93V10.1444L289.657 35.4999H301.648L312.578 9.71665V35.4999H322V0.5H316.494Z"
            fill="#1F3B84"/>
        <path d="M233.048 24.7277V0.5H223.626V35.4999H233.986L253.522 11.6611V35.4999H262.943V0.5H252.421L233.048 24.7277Z"
              fill="#1F3B84"/>
        <path
            d="M208.25 0.5L198.625 11.2722L189.326 0.5H177.049L192.466 18.1944L177.049 35.4999H187.654L197.687 24.4555L207.19 35.4999H219.466L203.927 17.6111L219.466 0.5H208.25Z"
            fill="#1F3B84"/>
        <path d="M336.5 0.5V35.5H339.5V0.5H336.5Z" fill="#1F3B84" mask="url(#path-1-inside-1_1914_204)"/>
    </svg>
;

const Logo = () => {
    return (
        <div className={st['logo']}>
            {uralchemLogo}
            <span className={st['logo__text']}>{'Потому что еда нужна каждому'}</span>
        </div>
    );
};

export default Logo;